import * as React from 'react';
import { SIMPLIFY_COLORS } from '../../../../constants/colors';
import { FC } from 'react';
import { IIconProps } from '../../types';

export const ArrowDown12: FC<IIconProps> = props => {
  const { color: _color } = props;

  const color = _color ? SIMPLIFY_COLORS[_color] : SIMPLIFY_COLORS.primary;

  return (
    // oxlint-disable-next-line react/forbid-elements
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.9 9.19999C16.5 8.79999 15.9 8.79999 15.5 9.19999L12 12.7L8.50005 9.19999C8.10005 8.79999 7.50005 8.79999 7.10005 9.19999C6.70005 9.59999 6.70005 10.2 7.10005 10.6L11.3 14.8C11.5 15 11.7 15.1 12 15.1C12.3 15.1 12.5 15 12.7 14.8L16.9 10.6C17.3 10.2 17.3 9.59999 16.9 9.19999Z"
        fill={color}
      />
    </svg>
  );
};
